export default __webpack_public_path__ + "static/media/atza-ui.1b2a8cf0.jpg";